import type { TableFootProps } from "./interfaces";

export const TableFoot = ({ className, children }: TableFootProps) => (
  <tfoot className={className}>{children}</tfoot>
);
